import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiReceiptsMyGet } from '@/entities/receipts/modules/api/receipts';

export const useMyReceipts = () =>
  useFetch({
    api: apiReceiptsMyGet,
    keywords: queryKeys.receipts.my,
    staleTime: 60_000,
  });
